import { WappMode } from '@weblite-wapps/protocol'
import {
  VitrineWappPanel,
  WorkbenchWappPanel,
  GeneralIssueWappPanel,
  CallWappPanel,
  CourseVitrineWappPanel,
} from '$logic/wapp-panels/static-wapp-panels'

export type StaticPanelType = 'general-issue' | 'workbench' | 'vitrine'   | 'courseVitrine' | 'call'

export enum StaticPanelWappId {
  TEACHER_WORKBENCH = '61517157526d2ee0f383a6fe',
  STUDENT_WORKBENCH = '6189438ebc475f2176905e2d',
  GENERAL_ISSUE = '6064cc8d39a3de28988c88e6',
  VITRINE = '63371025fbb2de203e2c9738',
  COURSE_VITRINE = 'vitrine-course-vitrine',
  CALL = 'call-call',
  GROUP_CALL = 'call-meet',
  LIVE = 'call-live',
  CLASSROOM = 'call-classroom',
  TRIBUNE = 'call-tribune',
}

export const wappIdToStaticPanel = {
  [StaticPanelWappId.TEACHER_WORKBENCH]: WorkbenchWappPanel,
  [StaticPanelWappId.STUDENT_WORKBENCH]: WorkbenchWappPanel,
  [StaticPanelWappId.GENERAL_ISSUE]: GeneralIssueWappPanel,
  [StaticPanelWappId.VITRINE]: VitrineWappPanel,
  [StaticPanelWappId.COURSE_VITRINE]: CourseVitrineWappPanel,
  [StaticPanelWappId.CALL]: CallWappPanel,
  [StaticPanelWappId.GROUP_CALL]: CallWappPanel,
  [StaticPanelWappId.LIVE]: CallWappPanel,
  [StaticPanelWappId.CLASSROOM]: CallWappPanel,
  [StaticPanelWappId.TRIBUNE]: CallWappPanel,
}

export const staticPanelNameToStaticPanel = {
  'general-issue': GeneralIssueWappPanel,
  workbench: WorkbenchWappPanel,
  vitrine: VitrineWappPanel,
  courseVitrine: CourseVitrineWappPanel,
  call: CallWappPanel,
}

export const wappIdToStaticPanelName: Record<
  StaticPanelWappId,
  StaticPanelType
> = {
  [StaticPanelWappId.VITRINE]: 'vitrine',
  [StaticPanelWappId.STUDENT_WORKBENCH]: 'workbench',
  [StaticPanelWappId.TEACHER_WORKBENCH]: 'workbench',
  [StaticPanelWappId.GENERAL_ISSUE]: 'general-issue',
  [StaticPanelWappId.COURSE_VITRINE]: 'courseVitrine',
  [StaticPanelWappId.CALL]: 'call',
  [StaticPanelWappId.GROUP_CALL]: 'call',
  [StaticPanelWappId.LIVE]: 'call',
  [StaticPanelWappId.CLASSROOM]: 'call',
  [StaticPanelWappId.TRIBUNE]: 'call',
}
export const getStaticPanelByName = (name: StaticPanelType) =>
  staticPanelNameToStaticPanel[name] || null

export const getStaticPanelByWappId = (wappId: StaticPanelWappId) =>
  wappIdToStaticPanel[wappId] || null

export const getStaticPanelByWappSessionId = (sessionId: string) => {
  const panels = Object.values(staticPanelNameToStaticPanel)
  for (const panel of panels)
    if (panel.getWappMeta()?.wappSessionId === sessionId) return panel

  return null
}

export const isValidStaticWapp = ({
  wappId,
  mode,
}: {
  wappId: string
  mode: WappMode
}) =>
  mode === WappMode.STATIC &&
  Boolean(wappIdToStaticPanel[wappId as StaticPanelWappId])
